import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap';
import Button from '../../../common/Button';
import { ConfirmLawyerLetterModalStyled } from "./ConfirmLawyerLetterModal.styled";
import ContentLoader from '../../../common/simple/ContentLoader';

const ConfirmLawyerLetterModal = ({ show, onModalHide, onConfirm, isLoading }) => {
    const { t } = useTranslation();
    const ltr = useSelector(state => state.common.ltrEnabled);

    const handleConfirm = () => {
        onConfirm();
        // onModalHide();
    }

    return (
        <ConfirmLawyerLetterModalStyled
            show={show}
            onHide={onModalHide}
            centered
            size='lg'
            ltr={ltr}
        >
            <span
                className={'modal-close'}
                onClick={onModalHide}
            >
                &#215;
            </span>
            <div className='set-expense-title'>
                {t('buildings.nav_bar_lawyer_letter_title')}
            </div>

            <Modal.Body>
                <div style={{textAlign: 'center'}}>{t('buildings.nav_bar_lawyer_letter_subtitle')}</div>
                <div style={{display: 'flex', justifyContent: 'center', marginTop: '32px'}}>
                  {isLoading ? 
                      <ContentLoader width={74} height={74} /> : 
                      <Button
                          type='button'
                          onClick={handleConfirm}
                          rounded={false}
                          disabled={isLoading}
                      >
                          {t('buildings.nav_bar_lawyer_letter_button')}
                      </Button>
                  }
                </div>
            </Modal.Body>
        </ConfirmLawyerLetterModalStyled>
    )
}

export default ConfirmLawyerLetterModal;
